<template>
  <khrc-navbar/>
  <research-officer-detail-component />
</template>

<script>
import ResearchOfficerDetailComponent from "@/components/ResearchOfficerDetailComponent.vue";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  components: {
    KhrcNavbar,
    ResearchOfficerDetailComponent,
  },
};
</script>

<style></style>
